import DottedList from 'components/dotted-list';
import style from './styles.module.scss';
import Button from 'components/button';
import AccompanimentReitEstimate from './accompanimentReitEstimate';
import { toPercent, toReadablePrice } from 'lib/utils';
import { useDataEstimateContext } from 'screens/estimate/hooks/useModalContex';
import { useState } from 'react';
import { IMortgageInfo } from 'screens/estimate/interfaces';
import ModalRedirectToPageWizardBuy, {
  TModeBuyModal,
} from '../modals/modalAnalogs/outOfSystem/modalRedirectToPageWizardBuy';
import { MarketTypes } from 'api/types';

interface IBuyEstimateProps {
  averageMarketPrice: string;
  mortgageInfo: IMortgageInfo;
  isSecondary: boolean;
}

const BuyEstimate = ({ averageMarketPrice, mortgageInfo, isSecondary }: IBuyEstimateProps) => {
  const { dataModal } = useDataEstimateContext();
  // out of system
  const [isOpen, setIsOpen] = useState(false);
  const [modeModal, setModModal] = useState<TModeBuyModal>('buy');

  const handleClickBuy = () => {
    setModModal('buy');
    handleSetIsOpenModal(true);
  };

  const handleClickTradeIn = () => {
    setModModal('tarde-in');
    handleSetIsOpenModal(true);
  };

  const handleSetIsOpenModal = (value: boolean) => {
    setIsOpen(value);
  };

  return (
    <div className={style.buy}>
      <div className={style.buy__container}>
        <div className={style.buy__dotedList}>
          <DottedList
            items={[
              { label: 'Стоимость объекта', value: averageMarketPrice },
              {
                label: 'Ставка по ипотеке',
                value: toPercent(mortgageInfo.percent),
              },
              {
                label: 'Срок кредитования',
                value: mortgageInfo.periodMonth + ' мес.',
              },
            ]}
          />
        </div>

        <div className={style.buy__table}>
          <table width={'100%'}>
            <thead>
              <tr>
                <th colSpan={2}>Первоночальный взнос</th>
                <th>Ежемесячный платеж</th>
              </tr>
            </thead>
            <tbody>
              {mortgageInfo.calculations.map((calculation) => {
                return (
                  <tr>
                    <td>{toPercent(calculation.initialPaymentPercent)}</td>
                    <td>{toReadablePrice(calculation.initialPayment)}</td>
                    <td>{toReadablePrice(calculation.monthlyPayment)}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        {isSecondary && (
          <div className={style.buy__buttons}>
            {/* <Button label='Помощь в покупке' variant='dark' onClick={handleClickBuy} /> */}
            <Button label='Купить в Trade-in' variant="dark" onClick={handleClickTradeIn} />
          </div>
        )}

         {isSecondary && (
          <ModalRedirectToPageWizardBuy
            isOpen={isOpen}
            onDismiss={handleSetIsOpenModal}
            data={dataModal}
            mode={modeModal}
          />
        )}

        {/* <div className={style.buy__accompanimentReit}>
          <AccompanimentReitEstimate
            marketType={isSecondary ? MarketTypes.SECONDARY : MarketTypes.PRIMARY}
          />
        </div>  */}
      </div>
    </div>
  );
};

export default BuyEstimate;
